import React from 'react';
import { AlertCircle, ChevronDown } from 'lucide-react';
interface Option {
  value: string;
  label: string;
}
interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  error?: string;
  id: string;
  options: Option[];
  placeholder?: string;
}
export function FormSelect({
  label,
  error,
  id,
  options,
  placeholder = 'Select an option',
  className = '',
  ...props
}: FormSelectProps) {
  return <div className="space-y-1.5" data-id="element-52">
      <label htmlFor={id} className="block text-sm font-medium text-slate-700 transition-colors" data-id="element-53">
        {label}
      </label>
      <div className="relative" data-id="element-54">
        <select id={id} className={`
            w-full px-3 py-2.5 rounded-lg border bg-white text-slate-900 text-sm
            transition-all duration-200 ease-in-out appearance-none
            focus:outline-none focus:ring-2 focus:ring-offset-1
            disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-slate-50
            ${!props.value ? 'text-slate-400' : 'text-slate-900'}
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-100' : 'border-slate-200 hover:border-slate-300 focus:border-blue-500 focus:ring-blue-100'}
            ${className}
          `} {...props} data-id="element-55">
          <option value="" disabled hidden data-id="element-56">
            {placeholder}
          </option>
          {options.map(option => <option key={option.value} value={option.value} className="text-slate-900" data-id="element-57">
              {option.label}
            </option>)}
        </select>

        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none flex items-center gap-2" data-id="element-58">
          {error && <div className="text-red-500 animate-in fade-in zoom-in duration-200" data-id="element-59">
              <AlertCircle size={16} data-id="element-60" />
            </div>}
          <ChevronDown size={16} className={`transition-colors ${error ? 'text-red-400' : 'text-slate-400'}`} data-id="element-61" />
        </div>
      </div>
      {error && <p className="text-xs text-red-500 font-medium animate-in slide-in-from-top-1 duration-200" data-id="element-62">
          {error}
        </p>}
    </div>;
}